// How often the source is checked for new tasks: presets, or minutes typed by the user.
import { Input } from "rizzui";

import { useT } from "../../../i18n";
import { FieldSet, Segmented } from "../../../ui/Segmented";
import { type Cadence, CADENCE_PRESETS, cadenceMinutes, MAX_MINUTES } from "../cadence";

export function CadencePicker({ value, onChange }: { value: Cadence; onChange: (next: Cadence) => void }) {
  const t = useT().tasks.create.cadence;
  const options = [...CADENCE_PRESETS.map((m) => ({ key: m, label: t.presets[m] })), { key: "custom" as const, label: t.custom }];
  const invalid = value.preset === "custom" && value.custom.trim() !== "" && cadenceMinutes(value) === null;
  return (
    <FieldSet legend={t.label} hint={t.hint}>
      <div className="flex flex-wrap items-center gap-3">
        <Segmented label={t.label} options={options} value={value.preset} onChange={(preset) => onChange({ ...value, preset })} />
        {value.preset === "custom" ? (
          <Input
            aria-label={t.minutes}
            className="w-36"
            inputMode="numeric"
            value={value.custom}
            placeholder={`1–${MAX_MINUTES}`}
            suffix={t.minutesSuffix}
            error={invalid ? t.range : undefined}
            onChange={(e) => onChange({ ...value, custom: e.target.value })}
          />
        ) : null}
      </div>
    </FieldSet>
  );
}
